import React from 'react';
import './Drumpad.css';

class Drumpad extends React.Component{
    render(){
        return (
            <a href="#" className="drum-pad" id={this.props.count}>
            <div className="drum" 
                onClick={() =>
                     {return this.props.clickablePlay(this.props.pad) }}
             >
            
                 {this.props.pad}
                 <audio className="clip" id={this.props.pad}
                    src="https://s3.amazonaws.com/freecodecamp/drums/Heater-1.mp3" 
                   type="audio/mpeg"
                 >
                 </audio>
            </div>
             </a>
        );
    }
}

export default Drumpad;


// WEBPACK FOOTER //
// ./src/Drumpad.js